import dayjs from 'dayjs';
import actions from './actions';
import type { NotesState} from './models';
import { adapter } from './models';

const initialState: NotesState = adapter.getInitialState({
  selected: '',
  createLocationText: '',
  createFieldId: null,
  dateRange: [dayjs().subtract(1, 'month').toDate(), dayjs().toDate()],
  filter: {
    selectedFieldsIds: [],
    imageryDate: undefined,
    noteDate: undefined,
    tags: [],
    sources: ['imagery', 'protector'],
    dateFilter: undefined,
  },
  currentSelectedNote: undefined,
  noteDashboard: undefined,
});

const reducer = (state = initialState, action: any): NotesState => {
  switch (action.type) {
    case actions.SET_CREATE_LOCATION:
      return {
        ...state,
        createLocationText: action.payload,
      };
    case actions.SET_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };
    case actions.ICON_CLICK:
      return {
        ...state,
        currentSelectedNote: action.payload,
      };
    case actions.SET_NOTES_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    case actions.SET_CREATE_FIELD:
      return {
        ...state,
        createFieldId: action.payload,
      };
    case actions.SELECT:
      return {
        ...state,
        selected: action.payload,
      };
    case actions.SET_NOTE_DASHBOARD:
      return {
        ...state,
        noteDashboard: action.payload,
      };

    default:
      return state;
  }
};

const { selectAll } = adapter.getSelectors();

export const selectAllNotes = selectAll;

export default reducer;
